const javaSetting = {
    'sit': 'https://moyin-gateway-sit.moyin.com',
    'pre': 'https://moyin-gateway-pre.moyin.com',
    'production': 'https://moyin-gateway.moyin.com',
    'development': 'https://moyin-gateway-pre.moyin.com',//本地链联调改这个改这个
  }
  const baohuoJavaSetting = {
    'sit': 'https://baohuo-gateway-pre.mobvoi.com',
    'pre': 'https://baohuo-gateway-pre.mobvoi.com',
    'production': 'https://baohuo-gateway.mobvoi.com',
    'development': 'https://baohuo-gateway-pre.mobvoi.com',
  }
  const crawlerSetting={
    'sit': 'https://moyin-audio-video-crawler-sit.moyin.com',
    'pre': 'https://moyin-audio-video-crawler-pre.moyin.com',
    'production': 'https://moyin-audio-video-crawler.moyin.com',
    'development': 'https://moyin-audio-video-crawler-pre.moyin.com',
  }

  const nodeTtsSetting = {
    'sit': '',
    'pre': '',
    'production': '',
    'development': 'https://m-sit.moyin.com',
  }
  export default javaSetting[process.env.VUE_APP_ENV || 'production']

  export const baohuoJavaHost = baohuoJavaSetting[process.env.VUE_APP_ENV || 'production']
  export const nodeTTSHost = nodeTtsSetting[process.env.VUE_APP_ENV || 'production']

  export let crawlerHost = crawlerSetting[process.env.VUE_APP_ENV || 'production']